import { useSelector } from 'react-redux';
import { AppState } from '../../store/AppState';
import { DealerState } from '../../types/DealerState';
import { useUserDealer } from '../UseUserDealer';

export const useHeader = (currentUrl: string): HeaderType => {
  const { featureToggle } = useSelector<AppState, DealerState>((state) => state.dealer);
  const { isIncentiveAdvantageType, isEssentialType } = useUserDealer();

  const isReportingRoute = (): boolean => {
    return (
      (currentUrl.indexOf('reporting') > -1 || currentUrl.indexOf('reports') > -1) &&
      currentUrl.indexOf('digital-audience') == -1
    );
  };

  const isUpdatingPredictionsRoute = (): boolean => {
    return currentUrl.indexOf('updating-predictions') > -1;
  };

  const isActive = (name: string): boolean => {
    return currentUrl.indexOf(name) > -1;
  };

  const currentHomePage = (): string | null => {
    if (isIncentiveAdvantageType) {
      return '/essential/dashboard';
    } else if (isEssentialType) {
      return '/portfolio/all';
    } else {
      return localStorage.getItem('homePageOptionUrl');
    }
  };

  return {
    isReportingRoute,
    isUpdatingPredictionsRoute,
    isActive,
    currentHomePage,
  };
};

type HeaderType = {
  isReportingRoute: () => boolean;
  isUpdatingPredictionsRoute: () => boolean;
  isActive: (name: string) => boolean;
  currentHomePage: () => string;
};
